export default function Footer() {
  return (
    <footer className="text-center text-sm bg-gray-200 text-gray-500 py-4 border-t">
      © {new Date().getFullYear()} Our Lady Queen of Martyrs. All rights reserved.
    </footer>
  );
}